import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leasePaymentProviderMandateRequestTemplates = [
  {
    id: '-131001',
    language: Language.EN,
    subject: 'Activate the direct debit mandate for your lease',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_PAYMENT_PROVIDER_MANDATE_REQUEST,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>As part of the management of your lease at <strong>{{getLeaseMainAddress lease}}</strong>, we invite you to activate automatic payment of your rent and charges via secure bank direct debit (SEPA).</p>
        <p></p>
        <p>This payment method allows you to:</p>
        <ul>
          <li>avoid any missed payments,</li>
          <li>guarantee timely payment each month,</li>
          <li>simplify the administrative management of your file.</li>
        </ul>
        <p></p>
        <p>To activate this service, simply complete your direct debit mandate securely via the following link:</p>
        <p>{{paymentProviderMandateLinkTag paymentProviderMandateLink language}}</p>
        <p></p>
        <p>This mandate only authorises the direct debit of future amounts related to your lease (upcoming rent and charges). Any amounts currently outstanding must be settled separately by bank transfer.</p>
        <p></p>
        <p>You of course retain full control over your account and can revoke this mandate at any time with your bank.</p>
        <p></p>
        <p>Once the mandate is validated, rent and charges will be automatically debited according to the terms set out in your lease.</p>
        <p></p>
        <p>If you have any questions or would like more information, please do not hesitate to contact us.</p>
        <p></p>
        <p>Thank you for your trust.</p>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-131002',
    language: Language.FR,
    subject: 'Activez le mandat de prélèvement bancaire de votre bail',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_PAYMENT_PROVIDER_MANDATE_REQUEST,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>Dans le cadre de la gestion de votre bail situé <strong>{{getLeaseMainAddress lease}}</strong>, nous vous proposons d'activer le paiement automatique de votre loyer et de vos charges via un prélèvement bancaire sécurisé (SEPA).</p>
        <p></p>
        <p>Ce mode de paiement vous permet de :</p>
        <ul>
          <li>éviter tout oubli de paiement,</li>
          <li>garantir le paiement à temps chaque mois,</li>
          <li>simplifier la gestion administrative de votre dossier.</li>
        </ul>
        <p></p>
        <p>Pour activer ce service, il vous suffit de compléter votre mandat de prélèvement en toute sécurité via le lien suivant :</p>
        <p>{{paymentProviderMandateLinkTag paymentProviderMandateLink language}}</p>
        <p></p>
        <p>Ce mandat autorise uniquement le prélèvement des montants futurs liés à votre bail (loyers et charges à venir). Les éventuels montants restant dus à ce jour doivent être réglés séparément par virement.</p>
        <p></p>
        <p>Vous conservez bien entendu le contrôle total sur votre compte et pouvez révoquer ce mandat à tout moment auprès de votre banque.</p>
        <p></p>
        <p>Une fois le mandat validé, les loyers et charges seront automatiquement prélevés selon les modalités prévues dans votre bail.</p>
        <p></p>
        <p>Si vous avez la moindre question ou souhaitez davantage d'informations, nous restons bien entendu à votre disposition.</p>
        <p></p>
        <p>Nous vous remercions pour votre confiance.</p>
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-131003',
    language: Language.NL,
    subject: 'Activeer het domiciliëringsmandaat voor uw huurovereenkomst',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_PAYMENT_PROVIDER_MANDATE_REQUEST,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>In het kader van het beheer van uw huurovereenkomst op <strong>{{getLeaseMainAddress lease}}</strong>, nodigen wij u uit om de automatische betaling van uw huur en kosten te activeren via een veilige bankdomiciliëring (SEPA).</p>
        <p></p>
        <p>Deze betaalmethode stelt u in staat om:</p>
        <ul>
          <li>elke vergeten betaling te vermijden,</li>
          <li>tijdige betaling elke maand te garanderen,</li>
          <li>het administratieve beheer van uw dossier te vereenvoudigen.</li>
        </ul>
        <p></p>
        <p>Om deze dienst te activeren, voltooit u gewoon uw domiciliëringsmandaat veilig via de volgende link:</p>
        <p>{{paymentProviderMandateLinkTag paymentProviderMandateLink language}}</p>
        <p></p>
        <p>Dit mandaat machtigt uitsluitend de inning van toekomstige bedragen met betrekking tot uw huurovereenkomst (toekomstige huur en kosten). Eventuele op dit moment nog openstaande bedragen moeten afzonderlijk via overschrijving worden betaald.</p>
        <p></p>
        <p>U behoudt uiteraard de volledige controle over uw rekening en kunt dit mandaat te allen tijde herroepen bij uw bank.</p>
        <p></p>
        <p>Zodra het mandaat is gevalideerd, worden huur en kosten automatisch geïnd volgens de modaliteiten die in uw huurovereenkomst zijn vastgelegd.</p>
        <p></p>
        <p>Als u vragen heeft of meer informatie wenst, staan wij uiteraard tot uw beschikking.</p>
        <p></p>
        <p>Wij danken u voor uw vertrouwen.</p>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-131004',
    language: Language.DE,
    subject: 'Aktivieren Sie das Lastschriftmandat für Ihren Mietvertrag',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_PAYMENT_PROVIDER_MANDATE_REQUEST,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{listAllTenants lease}},</p>
        <p></p>
        <p>Im Rahmen der Verwaltung Ihres Mietvertrags unter <strong>{{getLeaseMainAddress lease}}</strong> laden wir Sie ein, die automatische Zahlung Ihrer Miete und Nebenkosten per sicherem Lastschriftverfahren (SEPA) zu aktivieren.</p>
        <p></p>
        <p>Diese Zahlungsmethode ermöglicht es Ihnen:</p>
        <ul>
          <li>vergessene Zahlungen zu vermeiden,</li>
          <li>eine pünktliche Zahlung jeden Monat zu gewährleisten,</li>
          <li>die administrative Verwaltung Ihrer Akte zu vereinfachen.</li>
        </ul>
        <p></p>
        <p>Um diesen Service zu aktivieren, füllen Sie einfach Ihr Lastschriftmandat sicher über folgenden Link aus:</p>
        <p>{{paymentProviderMandateLinkTag paymentProviderMandateLink language}}</p>
        <p></p>
        <p>Dieses Mandat ermächtigt ausschließlich die Einziehung zukünftiger Beträge im Zusammenhang mit Ihrem Mietvertrag (zukünftige Mieten und Nebenkosten). Etwaige derzeit noch ausstehende Beträge müssen separat per Überweisung beglichen werden.</p>
        <p></p>
        <p>Sie behalten selbstverständlich die volle Kontrolle über Ihr Konto und können dieses Mandat jederzeit bei Ihrer Bank widerrufen.</p>
        <p></p>
        <p>Sobald das Mandat bestätigt ist, werden Miete und Nebenkosten gemäß den in Ihrem Mietvertrag festgelegten Bedingungen automatisch eingezogen.</p>
        <p></p>
        <p>Wenn Sie Fragen haben oder weitere Informationen wünschen, stehen wir Ihnen selbstverständlich gerne zur Verfügung.</p>
        <p></p>
        <p>Wir danken Ihnen für Ihr Vertrauen.</p>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
